export const MODULES = [
  {
    id: "akademik",
    title: "Manajemen Akademik & Rapor",
    description:
      "Kurikulum Merdeka/K13, jadwal pelajaran otomatis, pembagian kelas, hingga cetak Rapor Digital Kemdikbud.",
    icon: "GraduationCap",
  },
  {
    id: "keuangan",
    title: "Keuangan & SPP Otomatis",
    description:
      "Tagihan SPP berkala, integrasi Virtual Account / QRIS, pengingat WhatsApp ke wali murid, dan arus kas real-time.",
    icon: "CreditCard",
  },
  {
    id: "gaji",
    title: "Penggajian Guru & Staf",
    description:
      "Gaji pokok, tunjangan wali kelas/ekskul, potongan absensi otomatis, hingga cetak slip gaji digital sekali klik.",
    icon: "Receipt",
  },
  {
    id: "perpustakaan",
    title: "Perpustakaan Digital",
    description:
      "Katalog buku fisik & digital, sirkulasi peminjaman barcode/QR, denda otomatis, dan rekap minat baca siswa.",
    icon: "BookOpen",
  },
  {
    id: "lms",
    title: "LMS & Rapor Dinas Sync",
    description:
      "Ruang belajar online, ujian berbasis komputer (CBT), tugas interaktif, dan sinkronisasi ke sistem dinas.",
    icon: "Laptop",
  },
  {
    id: "buku_penghubung",
    title: "Buku Penghubung Ortu",
    description:
      "Komunikasi guru dan wali murid: catatan sikap, prestasi, pengumuman sekolah, hingga konseling terpadu.",
    icon: "MessageSquare",
  },
  {
    id: "absensi",
    title: "Absensi Real-time (QR & RFID)",
    description:
      "Kehadiran siswa & guru berbasis Scan QR / Kartu RFID dengan notifikasi WhatsApp instan ke HP Orang Tua.",
    icon: "UserCheck",
  },
  {
    id: "backup",
    title: "Backup & Keamanan Otomatis",
    description:
      "Enkripsi standar perbankan, backup harian ke cloud terisolasi per sekolah, integritas data 99.99%.",
    icon: "ShieldCheck",
  },
];

export const PRICING = [
  {
    id: "starter",
    name: "Paket Starter",
    capacity: "s.d. 100 Siswa",
    priceRange: "Rp 150rb – 300rb",
    period: "/ bulan",
    recommendedFor: "PAUD, TK, SD / SMP Swasta Perintis",
    features: [
      "Semua 8 Modul Dasar (Akademik, SPP, Absensi)",
      "Subdomain Khusus (namasekolah.sahabatpena.id)",
      "Notifikasi WhatsApp Standard",
      "Backup Data Otomatis Harian",
      "Dukungan Email & Chat",
    ],
    popular: false,
  },
  {
    id: "standard",
    name: "Paket Standard",
    capacity: "s.d. 300 Siswa",
    priceRange: "Rp 300rb – 600rb",
    period: "/ bulan",
    recommendedFor: "SMP & SMA / SMK Berkembang",
    features: [
      "Semua Fitur Paket Starter",
      "Modul CBT / Ujian Online LMS",
      "Integrasi Payment Gateway (VA & QRIS)",
      "Pengingat Tagihan SPP Otomatis",
      "Prioritas Bantuan Teknis",
    ],
    popular: true,
  },
  {
    id: "pro",
    name: "Paket Pro / Unlimited",
    capacity: "Siswa Tak Terbatas",
    priceRange: "Rp 750rb – 1,5jt",
    period: "/ bulan",
    recommendedFor: "Sekolah Besar & Kompleks Yayasan",
    features: [
      "Kapasitas Siswa & Guru Unlimited",
      "Modul LMS Lengkap + Export Rapor Dinas",
      "Multi-kampus / Multi-unit Yayasan",
      "Kustomisasi Domain Sekolah (.sch.id)",
      "Account Manager Khusus & Onboarding",
    ],
    popular: false,
  },
];

export const STEPS = [
  {
    step: "01",
    title: "Daftar & Pilih Subdomain",
    description:
      "Isi data sekolah dan tentukan alamat portal Anda, misal sman1jakarta.sahabatpena.id. Aktif dalam hitungan detik.",
    icon: "PenLine",
  },
  {
    step: "02",
    title: "Migrasi & Branding Sekolah",
    description:
      "Kami bantu impor data dari Excel/Dapodik. Pasang logo, kop surat, dan warna khas sekolah Anda sendiri.",
    icon: "UploadCloud",
  },
  {
    step: "03",
    title: "Pelatihan Operator & Guru",
    description:
      "Sesi onboarding via Zoom/offline agar seluruh admin, guru, dan wali kelas siap pakai dengan percaya diri.",
    icon: "Users",
  },
  {
    step: "04",
    title: "Sekolah Digital Berjalan",
    description:
      "Orang tua, guru, dan kepala sekolah mengakses portal masing-masing. Data 100% aman & terisolasi per sekolah.",
    icon: "Rocket",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Sejak pakai Sahabat PENA, tagihan SPP tidak lagi menumpuk. Orang tua dapat pengingat WhatsApp otomatis dan pembayaran lewat QRIS. Laporan keuangan yayasan jadi transparan.",
    name: "Hj. Siti Rahmawati, S.Pd.",
    role: "Kepala SLB Pelita Nusa",
    initials: "SR",
  },
  {
    quote:
      "Rapor digital dan absensi QR sangat memudahkan guru kami. Wali murid senang karena tahu anaknya sudah sampai sekolah lewat notifikasi langsung.",
    name: "Ahmad Fauzi, M.Pd.",
    role: "Waka Kurikulum SMP Islam Terpadu",
    initials: "AF",
  },
  {
    quote:
      "Satu subdomain untuk sekolah kami membuat kesan profesional di mata orang tua dan dinas. Setup-nya cepat dan tim support-nya responsif sekali.",
    name: "Dra. Ni Made Ayu",
    role: "Kepala SMA Harapan Bangsa",
    initials: "NA",
  },
];

export const FAQS = [
  {
    q: "Apakah data setiap sekolah aman dan terpisah?",
    a: "Ya. Setiap sekolah memiliki subdomain dan ruang data terisolasi penuh (multi-tenant). Guru atau admin satu sekolah tidak akan pernah bisa melihat data sekolah lain.",
  },
  {
    q: "Apa itu subdomain sekolah?",
    a: "Setiap sekolah mendapat alamat portal pribadi seperti namasekolah.sahabatpena.id lengkap dengan logo dan branding sendiri, layaknya aplikasi milik sekolah tersebut.",
  },
  {
    q: "Apakah ada masa uji coba gratis?",
    a: "Ada. Anda bisa mencoba seluruh modul selama 14 hari tanpa biaya dan tanpa kartu kredit. Cukup daftarkan sekolah Anda untuk memulai.",
  },
  {
    q: "Bagaimana proses migrasi data siswa & guru?",
    a: "Tim kami membantu impor data dari Excel maupun Dapodik saat proses onboarding, sehingga Anda tidak perlu memasukkan data satu per satu.",
  },
  {
    q: "Apakah bisa memakai domain sekolah sendiri (.sch.id)?",
    a: "Bisa, tersedia di Paket Pro. Sekolah dapat memasang domain sendiri (white-label) yang diarahkan ke sistem Sahabat PENA.",
  },
  {
    q: "Metode pembayaran apa yang didukung untuk SPP?",
    a: "Sistem mendukung Virtual Account dan QRIS dari berbagai bank, sehingga wali murid dapat membayar dengan mudah dan tercatat otomatis.",
  },
];
